import React from 'react'
import { cn } from '@/lib/utils'

export const InputGroup: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div className={cn('flex items-stretch', className)} {...props} />
)

export const InputGroupAddon: React.FC<React.HTMLAttributes<HTMLDivElement> & { addonType?: string }> = ({
  className, ...props
}) => (
  <div className={cn('flex items-center px-3 border border-border bg-muted text-sm rounded-md', className)} {...props} />
)

export const InputGroupText: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => (
  <span className={cn('flex items-center px-3 text-sm text-muted-foreground', className)} {...props} />
)
